import { render } from "./add-item.vue?vue&type=template&id=9f200868"
import script from "./add-item.vue?vue&type=script&lang=js"
export * from "./add-item.vue?vue&type=script&lang=js"

import "./add-item.vue?vue&type=style&index=0&id=9f200868&lang=sass"
script.render = render

export default script